import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const invoicesService = {
  addInvoices,
  getInvoicesList,
  getPaidInvoicesList,
  getAllInvoicesList,
  deleteInvoices,
  getInvoicesDetails,
  updateInvoices,
  executeInvoices,
  get_SiteList,
  get_site_details_id,
  removeChildInvoices,
  resendInvoices,
};

function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
  }
}

function addInvoices(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}invoices/add`, requestOptions)
    .then(handleResponse)
    .then(invoices => {
      return invoices;
    });
}

function getInvoicesList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}invoices/list`, requestOptions)
    .then(handleResponse)
    .then(invoices => {
      return invoices;
    });
}

function getPaidInvoicesList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}invoices/paid`, requestOptions)
    .then(handleResponse)
    .then(invoices => {
      return invoices;
    });
}


function getAllInvoicesList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}invoices/allinvoice`, requestOptions)
    .then(handleResponse)
    .then(invoices => {
      return invoices;
    });
} 
function deleteInvoices(invoicesIdASParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(invoicesIdASParams)
  };

  return fetch(
    `${appConfig.api.url}invoices/delete/${invoicesIdASParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(invoices => {
      return invoices;
    });
}

function getInvoicesDetails(invoicesIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}invoices/detail/${invoicesIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(invoicesDetails => {
      return invoicesDetails;
    });
}

function updateInvoices(propsData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}invoices/edit`, requestOptions)
    .then(handleResponse)
    .then(updatedInvoices => {
      return updatedInvoices;
    });
}

function executeInvoices(propsData) {

  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}invoices/executeInvoices`, requestOptions)
    .then(handleResponse)
    .then(executeInvoices => {
      return executeInvoices;
    });
}

function get_SiteList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page)
  };

  return fetch(`${appConfig.api.url}site/list`, requestOptions)
    .then(handleResponse)
    .then(sitelist => {
      return sitelist;
    });
}

function get_site_details_id(siteIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}site/detail/${siteIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(sitedata => {
      return sitedata;
    });
}

function removeChildInvoices(invoicesIdAsParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}invoices/delete-child/${invoicesIdAsParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function resendInvoices(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}invoices/resend-invoices`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/invoicesService.js